// ── THE SEAM ────────────────────────────────────────────────────────────────
// Stages 01-03 (field, substrate, motion) fill this. Stages 04-06 (mark, ink,
// frame) consume it. It is the entire contract between the renderer-agnostic
// core and the backends: Canvas 2D walks it in a for-loop, Three hands it
// straight to a BufferAttribute with no marshalling.
//
// Interleaved layout, stride 6:  x  y  z  value  angle  alpha

export const STRIDE = 6
export const X = 0, Y = 1, Z = 2, VALUE = 3, ANGLE = 4, ALPHA = 5

export function createDrawList(capacity = 4096) {
  return { data: new Float32Array(capacity * STRIDE), count: 0, capacity }
}

export function reset(list) {
  list.count = 0
}

export function ensure(list, capacity) {
  if (capacity <= list.capacity) return list
  const next = new Float32Array(capacity * STRIDE)
  next.set(list.data)
  list.data = next
  list.capacity = capacity
  return list
}

export function push(list, x, y, z, value, angle, alpha) {
  if (list.count >= list.capacity) ensure(list, Math.ceil(list.capacity * 1.5) + 64)
  const o = list.count * STRIDE
  const d = list.data
  d[o + X] = x; d[o + Y] = y; d[o + Z] = z
  d[o + VALUE] = value; d[o + ANGLE] = angle; d[o + ALPHA] = alpha
  list.count++
}
